import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { Property, PropertyQueryParams } from '../models/property.model';

export abstract class PropertyGateway {
  abstract listProperties(params: PropertyQueryParams): Observable<ListResponse<Property>>;
}
